(() => {
  'use strict';
  // Klarna owns the message, eligibility and popup. Supply the displayed total
  // because configured PCs and catalog price additions exceed the variant price.
  function amountFromText(text) {
    const match = /^£((?:\d{1,3}(?:,\d{3})+|\d+)\.\d{2})$/.exec(text.trim());
    const amount = match ? Math.round(Number(match[1].replace(/,/g, '')) * 100) : 0;
    return Number.isSafeInteger(amount) && amount > 0 ? amount : null;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { amountFromText };
  if (typeof document === 'undefined') return;

  function initialize() {
    document.querySelectorAll('[data-elite-product-apps]').forEach(panel => {
      if (panel.dataset.klarnaBound) return;
      const root = panel.closest('.a31-product, .elite-product-main');
      const price = root?.querySelector('.a31-price, .elite-product-purchase-summary__current, .elite-product-price__current');
      if (!price) return;
      panel.dataset.klarnaBound = 'true';
      let pending = false;
      let lastAmount = null;
      function update() {
        pending = false;
        if (!panel.isConnected) return;
        const amount = amountFromText(price.textContent);
        const unavailable = !amount || ['loading', 'error'].includes(root.dataset.catalogPriceState);
        const placements = panel.querySelectorAll('klarna-placement');
        // The Shopify app also watches DOM changes and reapplies its own
        // productVariants price. Update that same placement-scoped input so it
        // agrees with the configured total instead of reverting to the case.
        if (!unavailable) {
          const records = window.appBlockPlacements || window.klarnaAppBlocksManager?.placements || [];
          const selectedId = new URLSearchParams(location.search).get('variant');
          records.forEach(record => {
            if (![...placements].some(placement => placement.id === record.selector)) return;
            record.variantPrice = amount;
            const variants = record.productVariants || [];
            const selected = variants.find(variant => String(variant.id) === selectedId)
              || variants.find(variant => variant.available) || variants[0];
            if (selected) selected.price = amount;
          });
        }
        placements.forEach(placement => {
          if (placement.hidden !== unavailable) placement.hidden = unavailable;
          if (!unavailable && placement.getAttribute('data-purchase-amount') !== String(amount)) {
            placement.setAttribute('data-purchase-amount', String(amount));
          }
        });
        if (!unavailable && placements.length && lastAmount !== amount) {
          lastAmount = amount;
          window.Klarna?.OnsiteMessaging?.refresh?.();
        }
      }
      function schedule() {
        if (pending) return;
        pending = true;
        requestAnimationFrame(update);
      }
      new MutationObserver(schedule).observe(price, { childList: true, characterData: true, subtree: true });
      new MutationObserver(schedule).observe(root, { attributes: true, attributeFilter: ['data-catalog-price-state'] });
      // The app inserts its placement asynchronously and may reset it on variants.
      new MutationObserver(schedule).observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-purchase-amount'] });
      root.addEventListener('change', schedule);
      let attempts = 0;
      const timer = setInterval(() => {
        update();
        if (++attempts >= 80 || !panel.isConnected) clearInterval(timer);
      }, 250);
      update();
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
